<template>
<svg viewBox="0 0 17 17" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-BanGongShiPin`]" width="1em" height="1em" v-bind="$attrs"><path d="M16.8325 12.4856H12.67V11.4541H15.7925V2.15651H1.22241V11.4541H4.34498V12.4856H0.179688V1.125H16.8325V12.4856Z"/><path d="M8.50624 12.0756L10.5048 14.5535H6.50768L8.50624 12.0756ZM8.50624 10.4219L4.34375 15.5879H12.6687L8.50624 10.4219V10.4219Z"/></svg>
</template>
<script>

export default {
  name: 'IconBanGongShiPin',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
